import { Autocomplete, Box, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
// import CircularSlider from '../../components/ManualCircleSlider/src/CircularSlider/index.tsx';
import CircularSlider from "advanced-react-circular-slider";
import TextureIcon from "@mui/icons-material/Texture";
import CheckIcon from "@mui/icons-material/Check";

import {
  FontStyle,
  QuestionData,
  defaultBottomPadding,
  defaultInnerStyle,
  defaultContainerStyle,
  Color,
} from "../../constants";
import CheckButton from "../CheckButton";
import HeartButton from "../HeartButton";
import TempDisplay from "../TempDisplay";
import { CustomPaper, StyledTextField } from "../AutocompleteUtils";
import { useSelector } from "react-redux";

const styles = {
  container: {
    width: "100%",
    height: "100%",
    position: "relative",
    paddingBottom: defaultBottomPadding,
  },
  inner: {
    ...defaultInnerStyle,
    paddingTop: "1.3rem",
  },
  circleContainer: {
    width: "310px",
    height: "270px",
    // px: '0.75rem',
    position: "relative",
    top: "14px",
    // paddingBottom: '150px',
    // paddingTop: '50px',
  },
  body: {
    ...FontStyle.body,
    fontSize: "1rem",
    textAlign: "center",
    lineHeight: "1.4",
    maxWidth: "500px",
  },
  label: {
    position: "absolute",
    top: "48%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  currencySelect: {
    marginTop: "3rem",
    ...FontStyle.body,
    fontSize: "0.83rem",
    border: "1px solid rgb(195,195,186)",
    borderRadius: "10px",
    backgroundColor: "rgb(255,255,255)",
  },
  currency: {
    width: "80px",
    padding: "0.33rem 0px",
    textAlign: "center",
    borderLeft: "1px solid rgb(195,195,186)",
    color: "rgb(195,195,186)",
    cursor: "pointer",
    "&:hover": {
      color: "#000",
    },
  },
  selectedCurrency: {
    color: "#000",
    fontWeight: "bold",
  },
  bar: {
    width: "100%",
    height: "1px",
    backgroundColor: "#000",
    opacity: "0.2",
  },
};
const numNeeded = 1;
const numMax = 600;
const numTitles = 0;

const progressColor = Color.mainGreen;

const Q12_Salary = ({
  selected,
  setSelected,
  setQuestionsDone,
  questionNum,
  options,
}) => {
  const defaultSalaryIdx = useSelector(
    (state) => state.survey.defaultSalaryIdx
  );
  useEffect(() => {
    setQuestionsDone((prev) => ({ ...prev, [questionNum]: true }));
    // if (selected[questionNum].includes(0)) {
    //   setQuestionsDone((prev) => ({ ...prev, [questionNum]: true }))
    // } else if (selected[questionNum].includes(1) && selected[questionNum].length > 1) {
    //   setQuestionsDone((prev) => ({ ...prev, [questionNum]: true }))
    // } else {
    //   setQuestionsDone((prev) => ({ ...prev, [questionNum]: false }))
    // }
  }, [selected]);
  // const [currencyIdx, setCurrencyIdx] = useState(1)
  const [amountIdx, setAmountIdx] = useState(defaultSalaryIdx);
  useEffect(() => {
    setSelected((s) => {
      return { ...s, [questionNum]: [amountIdx] };
    });
  }, [amountIdx]);
  // }, [currencyIdx, amountIdx])
  return (
    <Stack direction="column" sx={styles.container} alignItems="center">
      {/* <TempDisplay selected={selected} options={options} questionNum={questionNum} /> */}
      <Stack
        direction="column"
        sx={styles.circleContainer}
        alignItems="center"
        justifyContent="center"
        spacing={1}>
        <Stack
          direction="column"
          sx={styles.label}
          alignItems="center"
          justifyContent="center"
          spacing={1}>
          <Box sx={{ ...styles.body }}>Minimum</Box>
          {/* <Box sx={{ ...styles.body, fontSize: '3rem', fontWeight: 700 }}>{currencyIdx === 0 ? '€' : (currencyIdx === 3 ? '£' : '$')}{options[selected[questionNum][selected[questionNum].length - 1]]}k</Box> */}
          <Box sx={{ ...styles.body, fontSize: "3rem", fontWeight: 700 }}>
            ${options[selected[questionNum][selected[questionNum].length - 1]]}k
          </Box>
        </Stack>
        <Box
          sx={{
            "* & text": {
              display: "none",
            },
          }}>
          <CircularSlider
            width={310}
            min={numTitles}
            max={options.length - 1}
            dataIndex={defaultSalaryIdx}
            step={1}
            hideLabelValue
            renderLabelValue={null}
            knobSize={40}
            trackSize={24}
            progressSize={24}
            // knobColor='rgb(211,197,73)'
            knobColor={Color.mainGreen}
            progressColorFrom={progressColor}
            // progressColorFrom='rgb(246,231,83)'
            progressColorTo={progressColor}
            trackColor="rgb(225,225,220)"
            labelStep={1000} // janky but disables the 'labels' that form a ring
            onChange={(v) => {
              setAmountIdx(v.value);
            }}></CircularSlider>
        </Box>
      </Stack>
      {/* <Stack sx={{ width: '100%', paddingTop: '32px', paddingBottom: '0px', maxWidth: '500px' }} direction='row' alignItems='center' justifyContent='center' spacing={2}>
        <Box sx={styles.bar} /> */}
      {/* <Box>How we use this information:</Box>
        <Box sx={styles.bar} /> */}
      {/* </Stack> */}
      <Stack
        direction="column"
        sx={{
          ...styles.inner,
          paddingTop: "38px",
          paddingLeft: { xs: "8px", sm: 0 },
        }}
        alignItems="center"
        justifyContent="center"
        spacing={1}>
        <Stack
          direction="row"
          sx={{ ...FontStyle.headingBody, textAlign: "left", width: "100%" }}
          alignItems="left">
          How we use this information:
        </Stack>
        <Stack
          direction="row"
          sx={{ ...styles.body, textAlign: "left", width: "100%" }}
          alignItems="left">
          <Box sx={{ width: "30px", minWidth: "30px" }}>⏰</Box>
          <Box>
            We utilize this information solely for screening jobs and to enhance
            your search efficiency
          </Box>
        </Stack>
        <Stack
          direction="row"
          sx={{ ...styles.body, textAlign: "left", width: "100%" }}
          alignItems="left">
          <Box sx={{ width: "30px" }}>✅</Box>
          We do not disclose this information to companies
        </Stack>
        <Stack
          direction="row"
          sx={{ ...styles.body, textAlign: "left", width: "100%" }}>
          <Box sx={{ minWidth: "30px" }}>💼</Box>
          We suggest selecting a lower amount to avoid missing out on potential
          job opportunities
        </Stack>
      </Stack>

      {/* <Stack direction='row' sx={styles.currencySelect} alignItems='center'>
        <Box onClick={() => setCurrencyIdx(0)} sx={{ ...styles.currency, borderLeft: 'none', ...(currencyIdx === 0 && styles.selectedCurrency) }}>EUR (€)</Box>
        <Box onClick={() => setCurrencyIdx(1)} sx={{ ...styles.currency, ...(currencyIdx === 1 && styles.selectedCurrency) }}>USD ($)</Box>
        <Box onClick={() => setCurrencyIdx(2)} sx={{ ...styles.currency, ...(currencyIdx === 2 && styles.selectedCurrency) }}>CAD ($)</Box>
        <Box onClick={() => setCurrencyIdx(3)} sx={{ ...styles.currency, ...(currencyIdx === 3 && styles.selectedCurrency) }}>GBP (£)</Box>
      </Stack> */}
      {/* <Box sx={{ height: '50px' }} /> */}
    </Stack>
  );
};

export default Q12_Salary;
